<template>
  <transition name="fade">
    <new-message-mobile v-if="isUnReadMessage" />
  </transition>

  <transition name="fade">
    <TMmodal v-show="TMOpen" :isOpen="TMOpen" :type="'header'" @close="onCloseTM"/>
  </transition>

  <template v-if="type != 'empty'">
    <div class="fx mobile-editorial-nav">
      <ul class="fxhead">
        <!-- <li class="home" :class="{'out': side}"><a @click="side=!side"><em></em><span>menu</span></a></li> -->
        <li class="home" :class="{'on': $route.meta.gnbMenu === 'main'}"><a @click="goPageByName('mobileMain')"><em></em><span>홈</span></a></li>
        <li class="in" :class="{'on': $route.meta.gnbMenu === 'charge'}"><a @click="goPageByName('charge')"><em></em><span>{{$t('front.common.deposit')}}</span></a></li>
        <li class="outs" :class="{'on': $route.meta.gnbMenu === 'exchange'}"><a @click="goPageByName('exchange')"><em></em><span>{{$t('front.common.withdrawal')}}</span></a></li>
        <li class="point" :class="{'on': $route.meta.gnbMenu === 'point'}"><a @click="goPageByName('point')"><em></em><span>{{$t('front.common.point')}}</span></a></li>
        <li class="cs" :class="{'on': $route.meta.gnbMenu === 'cs'}"><a @click="goPageByName('qnaList')"><em></em><span>{{$t('front.common.cscenter')}}</span></a></li>
        <!-- <li class="msg" :class="{'on': $route.meta.gnbMenu === 'msg'}"><a @click="goPageByName('msg')"><em></em><span>{{$t('front.mypage.message')}}</span></a></li>
        <li class="home" :class="{'on': $route.meta.gnbMenu === 'betList'}"><a @click="goPageByName('betList')"><em></em><span>{{$t('front.mypage.betList')}}</span></a></li>
        <li class="my" :class="{'on': $route.meta.gnbMenu === 'myinfo'}"><a @click="goPageByName('myinfo')"><em></em><span>{{$t('front.common.mypage')}}</span></a></li> -->
      </ul>
    </div>

    <header class="mobile-editorial-header">
      <!--div class="noticeWrap">
        <div class="notice"><em>{{$t('front.common.notices')}}</em><span>{{$t('front.header.msg')}}</span></div>
        <div class="langbtn" @click="openLang()">
          <button class="langdropbtn" >
            <template v-if="$i18n.locale === 'ko'">
              <img src="@/assets_mobile/img/korea.png" /><span class="langsp">KO</span>
            </template>
            <template v-if="$i18n.locale === 'en'">
              <img src="@/assets/img/eng.png" /><span class="langsp">EN</span>
            </template>
            <template v-if="$i18n.locale === 'vn'">
              <img src="@/assets/img/vn.svg" /><span class="langsp">VN</span>
            </template>
            <img class="langbtnb" src="@/assets_mobile/img/langbtn.png" />
          </button>
          <div class="langdropdown" v-if="isOpenLang">
            <a href="#" :class="{'on': $i18n.locale === 'ko'}" @click="changeLocale('ko')">KR</a>
            <a href="#" :class="{'on': $i18n.locale === 'en'}" @click="changeLocale('en')">EN</a>
            <a href="#" :class="{'on': $i18n.locale === 'vn'}" @click="changeLocale('vn')">VN</a>
          </div>
        </div>
      </div-->
      <div class="header">
        <a @click="side=!side" :class="{'out': side}"><img src="@/assets_mobile/img/icon_yhome.svg" /></a>
        <h1 class="logo"><a @click="goPageByName('mobileMain')"><img src="@/assets/img/mega-orbit-logo.svg" alt="MEGA" /></a></h1>
        <div class="logininfowrap" v-if="userData">
          <a @click="goPageByName('qnaList')" class="icon"><img src="@/assets_mobile/img/icon_user2.svg" /></a>
        </div>
        <div class="logininfowrap" v-if="!userData">
          <!-- <a class="mloginbtn" @click="goPageByName('mobileJoin')">JOIN</a> -->
          <a class="icon" @click="goPageByName('mobileLogin')"><img src="@/assets_mobile/img/icon_user2.svg" /></a>
        </div>
      </div>
      <div v-if="userData">
        <div class="logininfowrap2">
          <ul class="mym">
            <li class="myc">
              <img src="@/assets_mobile/img/icon_user.svg" />
              <span>
                  <em>{{$t('front.common.nickName')}}</em>
                  {{userData.memNick}}
              </span>
            </li>
            <li class="myc" @click="goPageByName('charge')">
              <img src="@/assets/img/icon_wallet_deposit.svg" />
              <span>
                  <em>{{$t('front.cash.haveCash')}}</em>
                  {{userData.cashAmt ? thousand(userData.cashAmt.toString()): 0}}
              </span>
            </li>
            <li class="myc" @click="goPageByName('point')">
              <img src="@/assets/img/left/icon_left_point.svg" />
              <span>
                  <em>{{$t('front.cash.nav4')}}</em>
                  {{thousand(userData.pointAmt ? userData.pointAmt.toString() : '0')}}
              </span>
            </li>
            <li class="myc" @click="goPageByName('msgMain')">
              <img src="@/assets/img/left/icon_left_msg.svg" />
              <span>
                  <em>{{$t('front.mypage.message')}}</em>
                  {{thousand(unReadMessageCount ? unReadMessageCount.toString() : '0')}}
              </span>
            </li>
          </ul>
          <div class="logininfowrap">
            <a class="mloginbtn" :href="`https://${partnerDomain}/partnerMain`" target="_blank" v-if="userData.isPartnerMember && userData.isPartnerMember === 'Y'">{{$t('front.common.partner')}}</a>
            <a class="mloginbtn" @click="signOut()">{{$t('front.common.logout')}}</a>
          </div>
        </div>
      </div>
      <div class="topbanner">
        <div class="topbannerin">
            <div class="speakerIcon"><img src="@/assets/img/icon_mega.svg"/></div>
            <span class="">{{ flowNotice }}</span>
        </div>
      </div>
    </header>
    <!--a @click="goBack" class="back"><img src="@/assets_mobile/img/back.png" /></a>
    <a class="sideMenu" @click="side=!side" :class="{'out': side}"><em></em></a-->
    <transition name="side">
       <nav v-if="side" class="editorial-drawer" @click.self="side = false">
         <div class="nav-wrap">
            <div class="nav-head">
               <div class="header">
                 <h1 class="logo"><a @click="goPageByNamez('mobileMain')"><img src="@/assets/img/mega-orbit-logo.svg" alt="MEGA" /></a></h1>
                 <!--a v-if="userData" @click="goPageByNamez('msgMain')" class="mmsg"><img src="@/assets_mobile/img/message_off.png" /><span class="mgsn">{{thousand(unReadMessageCount ? unReadMessageCount.toString() : '0')}}</span></a>
                 <ul class="minfo" v-if="userData">
                   <li>
                      <span>{{userData.memNick}}</span>
                   </li>
                   <li>
                      <em>₩</em>
                      <span>{{userData.cashAmt ? thousand(userData.cashAmt.toString()): 0}}</span>
                   </li>
                   <li>
                      <span>{{userData.cashAmt ? thousand(userData.cashAmt.toString()): 0}}</span>
                   </li>
                   <li @click="goPageByName('point')">
                      <em>P</em>
                      <span>{{userData.pointAmt ? thousand(userData.pointAmt.toString()): 0}}</span>
                   </li>
                 </ul>
                 <div v-if="!userData">
                   <a class="mloginbtn" @click="goPageByNamez('mobileJoin')">JOIN</a>
                   <a class="mloginbtn on" @click.stop="goPageByNamez('mobileLogin')">LOGIN</a>
                 </div-->
               </div>
               <a class="sideMenu" @click="side=!side" :class="{'in': side}"><img src="@/assets/img/icon_x.svg" /></a>
            </div>
            <div v-if="userData" class="drawer-user">
              <div class="drawer-user-name">
                <span>MEMBER</span>
                <strong>{{userData.memNick}}</strong>
              </div>
              <div class="drawer-user-assets">
                <button type="button" @click="goPageByNamez('charge')">
                  <span>{{$t('front.cash.haveCash')}}</span>
                  <strong>{{userData.cashAmt ? thousand(userData.cashAmt.toString()) : 0}}</strong>
                </button>
                <button type="button" @click="goPageByNamez('point')">
                  <span>{{$t('front.common.point')}}</span>
                  <strong>{{userData.pointAmt ? thousand(userData.pointAmt.toString()) : 0}}</strong>
                </button>
              </div>
            </div>
            <div v-else class="drawer-auth">
              <a @click="goPageByNamez('mobileJoin')">{{$t('front.common.signup')}}</a>
              <a class="primary" @click.stop="goPageByNamez('mobileLogin')">{{$t('front.common.login')}}</a>
            </div>
            <div class="nav-con">
               <ul>
                  <li>
                      <a @click="goPageByNamez('charge')">
                         <img src="@/assets/img/icon_wallet_deposit.svg" />
                         <span>{{$t('front.common.deposit')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('exchange')">
                         <img src="@/assets/img/icon_atm_withdraw.svg" />
                         <span>{{$t('front.common.withdrawal')}}</span>
                      </a>
                  </li>
               </ul>
               <ul>
                  <li>
                      <a @click="goPageByNamez('noticeList')">
                         <img src="@/assets/img/left/icon_left_notice.svg" />
                         <span>{{$t('front.common.notice')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('qnaList')">
                         <img src="@/assets/img/left/icon_left_ask.svg" />
                         <span>{{$t('front.common.qna')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('faq')">
                         <img src="@/assets/img/left/icon_left_faq.svg" />
                         <span>{{$t('front.common.faq')}}</span>
                      </a>
                  </li>
               </ul>
               <ul>
                  <li>
                      <a @click="goPageByNamez('betList')">
                         <img src="@/assets/img/left/icon_left_bet.svg" />
                         <span>{{$t('front.mypage.betList')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('point')">
                         <img src="@/assets/img/left/icon_left_point.svg" />
                         <span>{{$t('front.common.point')}}</span>
                      </a>
                  </li>
                  <li>
                      <a @click="goPageByNamez('msg')">
                         <img src="@/assets/img/left/icon_left_msg.svg" />
                         <span>{{$t('front.mypage.message')}}</span>
                      </a>
                  </li>
                  <li>
                      <a v-if="userData" @click="goPageByNamez('info')">
                         <img src="@/assets/img/left/icon_left_info.svg" />
                         <span>{{$t('front.mypage.memInfoModify')}}</span>
                      </a>
                  </li>
                  <template v-if="userData">
                    <li v-if="userData.isPartnerMember && userData.isPartnerMember === 'Y'">
                        <a :href="`https://${partnerDomain}/partnerMain`" target="_blank" >
                          <img src="@/assets/img/left/icon_left_info.svg" />
                          <span>{{$t('front.common.partner')}}</span>
                        </a>
                    </li>
                  </template>
                  <!-- <li><a @click="onClickTM()"><img src="@/assets/img/left/icon_left_out.svg" /><span>통합머니 전환</span></a></li> -->
               </ul>
               <ul>
                  <li>
                      <a v-if="userData" @click="signOut()">
                         <img src="@/assets/img/icon_logout.svg" />
                         <span>{{$t('front.common.logout')}}</span>
                      </a>
                  </li>
               </ul>
               <!-- <ul class="sns" v-if="siteOption">
                <li>
                    <a @click="siteOption['sns1Link']">
                      <img src="@/assets/img/telegram.svg" />
                      <span>{{siteOption['sns1']}}<em>{{siteOption['sns1Id']}}</em></span>
                    </a>
                </li>
              </ul> -->
            </div>
          </div>
       </nav>
    </transition>
  </template>
</template>

<script>
import { mapState } from 'vuex'
import NewMessageMobile from '@/components/member/MessageMobile.vue'
import TMmodal from '@/components/common/TotalMoney.vue'
import { getFlowNotice } from '@/api/main'
import { getPartnerDomain } from '@/libs/constants'

export default {
  name: 'Header',
  components: { TMmodal, NewMessageMobile },
  props: [
    'type'
  ],
  data () {
    return {
      isOpenLang: false,
      side: false,
      TMOpen: false,
      flowNotice: ''
    }
  },
  watch: {
    async userData (newVal) {
      if (newVal) {
        this.getFlowNotice()
      }
    }
  },
  computed: {
    ...mapState([
      'userData',
      'unReadMessageCount',
      'siteOption'
    ]),
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    },
    partnerDomain () {
      return getPartnerDomain()
    },
    partnerPageLink () {
      return 'http://ptn.' + location.host
    }
  },
  mounted () {
    if (this.userData) {
      this.getFlowNotice()
    }
  },
  methods: {
    getFlowNotice () {
      getFlowNotice({}).then(res => {
        // console.log('flow', res)
        const result = res.data
        if (result.resultCode === '0') {
          this.flowNotice = result.data.content
        }
      })
    },
    async onClickTM () {
      const confirmMessage = '통합머니 전환을 진행하시겠습니까?'
      const confirmResult = await this.onConfirm(confirmMessage)
      if (confirmResult) {
        this.TMOpen = true
      }
    },
    onCloseTM () {
      this.TMOpen = false
    },
    openLang () {
      this.isOpenLang = !this.isOpenLang
    },
    onLogOut () {
      this.$root.signOut()
      this.$router.push({ name: 'main' })
      // location.reload()
    },
    goPageByNamez (name, params) {
      const query = { name: name }
      if (params) {
        query.params = params
      }
      this.$router.push(query)
      this.side = !this.side
    }
  }
}
</script>

<style scoped src="@/styles_mobile/header.css"></style>
<style scoped src="@/styles_mobile/common.css"></style>
<style scoped src="@/styles_mobile/swiper.min.css"></style>
<style scoped src="@/styles_mobile/subcommon.css"></style>
<style scoped>
header.mobile-editorial-header>.header {
  height: 58px;
  padding: 0 14px;
  border-bottom: 1px solid #29292d;
  background: #0c0c0e;
  box-shadow: none;
}
header.mobile-editorial-header h1.logo img {
  width: 132px;
  height: auto!important;
  max-height: 34px;
  object-fit: contain;
}
header.mobile-editorial-header>.header>a:first-child {
  width: 28px;
  height: 28px;
  display:flex;
  align-items:center;
  justify-content:center;
}
header.mobile-editorial-header>.header>a:first-child img {width:20px;filter:sepia(.45) saturate(.7)}
header.mobile-editorial-header .logininfowrap .icon {border-color:#8a7042;background:#181818}
header.mobile-editorial-header .logininfowrap .icon img {width:14px;height:14px}
header.mobile-editorial-header>.topbanner {display:none}
header.mobile-editorial-header .logininfowrap2 {border-bottom:1px solid #29292d;background:#141416}
header.mobile-editorial-header .mym {background:#1a1918}
header.mobile-editorial-header .myc span {color:#bda36f}
header.mobile-editorial-header .mloginbtn {border:1px solid #6f5a35;border-radius:7px;background:#211e18;color:#c9b681}
header.mobile-editorial-header .nav-wrap {background:#101011}
header.mobile-editorial-header .nav-head {border-bottom:1px solid #29292d}
header.mobile-editorial-header .nav-head h1.logo img {width:160px;max-height:42px}
header.mobile-editorial-header .nav-con li::after {background:#302e29}
header.mobile-editorial-header .nav-con li a {color:#c7b27f}
.mobile-editorial-nav .fxhead {
  height:60px;
  border-top:1px solid #302f30;
  background:rgba(15,15,16,.97);
  box-shadow:0 -8px 24px rgba(0,0,0,.36);
}
.mobile-editorial-nav .fxhead li {position:relative;background:transparent}
.mobile-editorial-nav .fxhead li.on {background:transparent}
.mobile-editorial-nav .fxhead li.on::after {content:'';position:absolute;left:50%;bottom:6px;width:4px;height:4px;border-radius:50%;background:#b6a06a;transform:translateX(-50%)}
.mobile-editorial-nav .fxhead li span {color:#a89b7e;font-size:10px}
.mobile-editorial-nav .fxhead li.on span {color:#d4bd8b}
.mobile-editorial-nav .fxhead li em {width:25px;height:25px;background-size:20px!important;filter:sepia(.5) saturate(.65)}
.mobile-editorial-nav .fxhead li.in em {background-image:url('../assets/img/icon_wallet_deposit.svg')!important;filter:none}
.mobile-editorial-nav .fxhead li.outs em {background-image:url('../assets/img/icon_atm_withdraw.svg')!important;filter:none}

nav.editorial-drawer {
  display:flex;
  justify-content:flex-end;
  background:rgba(0,0,0,.62);
  backdrop-filter:blur(4px);
}
nav.editorial-drawer .nav-wrap {
  position:relative;
  left:auto;
  right:0;
  width:min(88vw,360px);
  height:100%;
  overflow-y:auto;
  border-left:1px solid #302f30;
  background:#101011;
  background-image:none;
  box-shadow:-18px 0 50px rgba(0,0,0,.48);
}
nav.editorial-drawer .nav-head {
  display:flex;
  height:66px;
  padding:0 16px;
  align-items:center;
  justify-content:space-between;
  border-bottom:1px solid #29292d;
  box-sizing:border-box;
}
nav.editorial-drawer .nav-head .header {width:auto;height:auto;background:transparent}
nav.editorial-drawer .nav-head .header .logo {margin:0}
nav.editorial-drawer .nav-head .header .logo img {
  width:145px!important;
  height:auto!important;
  max-height:38px;
  object-fit:contain;
}
nav.editorial-drawer .sideMenu {
  position:static;
  display:flex;
  width:32px;
  height:32px;
  align-items:center;
  justify-content:center;
  border:1px solid #302f30;
  border-radius:6px;
  background:#171718;
}
nav.editorial-drawer .sideMenu img {width:14px;height:14px;opacity:.7}
.drawer-user {
  margin:14px;
  padding:16px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#151516;
}
.drawer-user-name {display:flex;flex-direction:column;gap:5px}
.drawer-user-name span {color:#77736f;font-size:8px;letter-spacing:.12em}
.drawer-user-name strong {color:#eeeae5;font-size:15px;font-weight:600}
.drawer-user-assets {display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:14px}
.drawer-user-assets button {
  min-width:0;
  padding:10px;
  border:0;
  border-radius:6px;
  background:#1d1d1e;
  text-align:left;
}
.drawer-user-assets span {display:block;overflow:hidden;color:#77736f;font-size:8px;white-space:nowrap}
.drawer-user-assets strong {display:block;overflow:hidden;margin-top:5px;color:#d1bb8b;font-size:11px;text-overflow:ellipsis}
.drawer-auth {display:flex;gap:8px;margin:14px}
.drawer-auth a {
  display:flex;
  flex:1;
  height:38px;
  align-items:center;
  justify-content:center;
  border:1px solid #343334;
  border-radius:6px;
  color:#aaa6a1;
  font-size:11px;
}
.drawer-auth a.primary {border-color:#8a7042;background:#8a7042;color:#f5f1e9}
nav.editorial-drawer .nav-con {
  display:block;
  max-width:none;
  margin:0;
  padding:0 14px 30px;
}
nav.editorial-drawer .nav-con>ul {padding:8px 0;border-bottom:1px solid #29292d}
nav.editorial-drawer .nav-con>ul:last-child {border-bottom:0}
nav.editorial-drawer .nav-con li {
  height:44px;
  margin:0;
  padding:0 8px;
  border-radius:6px;
  box-sizing:border-box;
}
nav.editorial-drawer .nav-con li::after {display:none}
nav.editorial-drawer .nav-con li:hover {background:#1b1b1e}
nav.editorial-drawer .nav-con li a {
  display:flex;
  width:100%;
  height:100%;
  gap:12px;
  align-items:center;
  color:#c7c2bc;
  font-size:11px;
}
nav.editorial-drawer .nav-con li a img {
  width:20px;
  height:20px;
  object-fit:contain;
  opacity:.68;
}
nav.editorial-drawer .nav-con li:hover a {color:#e5d5b3}
nav.editorial-drawer .nav-con li:hover a img {opacity:1}
.side-enter-active,
.side-leave-active {transition:opacity .22s ease}
.side-enter-active .nav-wrap,
.side-leave-active .nav-wrap {transition:transform .22s ease}
.side-enter,
.side-leave-to {opacity:0;transform:none}
.side-enter .nav-wrap,
.side-leave-to .nav-wrap {transform:translateX(100%)}

/* MEGA orbit mobile navigation */
header.mobile-editorial-header {
  border-bottom-color:rgba(107,228,255,.13);
  background:rgba(7,10,13,.96);
  box-shadow:0 10px 30px rgba(0,0,0,.22)
}
header.mobile-editorial-header>.header {
  border-bottom-color:rgba(107,228,255,.12);
  background:linear-gradient(90deg,#090e11,rgba(12,20,24,.98))
}
header.mobile-editorial-header h1.logo img {width:142px;max-height:32px}
header.mobile-editorial-header>.header>a:first-child img {filter:grayscale(1) brightness(2.25)}
header.mobile-editorial-header .logininfowrap .icon {
  border-color:rgba(107,228,255,.35);
  background:rgba(107,228,255,.07)
}
header.mobile-editorial-header .logininfowrap2 {
  border-bottom-color:rgba(107,228,255,.12);
  background:#0d1519
}
header.mobile-editorial-header .mym {background:#10191d}
header.mobile-editorial-header .myc span {color:#9cecff}
header.mobile-editorial-header .mloginbtn {
  border-color:rgba(107,228,255,.25);
  background:rgba(107,228,255,.07);
  color:#9cecff
}
.mobile-editorial-nav .fxhead {
  height:64px;
  border-top-color:rgba(107,228,255,.14);
  background:rgba(7,11,14,.97);
  box-shadow:0 -12px 32px rgba(0,0,0,.42)
}
.mobile-editorial-nav .fxhead li.on::after {
  bottom:5px;
  width:22px;
  height:2px;
  border-radius:2px;
  background:linear-gradient(90deg,#6be4ff,#c8ff63)
}
.mobile-editorial-nav .fxhead li span {color:#69777d}
.mobile-editorial-nav .fxhead li.on span {color:#eaf3f4}
.mobile-editorial-nav .fxhead li em {filter:grayscale(1) brightness(1.75)}
.mobile-editorial-nav .fxhead li.on em {filter:grayscale(1) brightness(2.6)}
nav.editorial-drawer .nav-wrap {
  border-left-color:rgba(107,228,255,.16);
  background:linear-gradient(180deg,#0d1519,#080c0f)
}
nav.editorial-drawer .nav-head {border-bottom-color:rgba(107,228,255,.12)}
nav.editorial-drawer .sideMenu {border-color:rgba(107,228,255,.16);background:#10191d}
.drawer-user {border-color:rgba(107,228,255,.13);background:#0e171b}
.drawer-user-name span {color:#66777e}
.drawer-user-assets button {background:rgba(107,228,255,.055)}
.drawer-user-assets strong {color:#a8edf9}
.drawer-auth a {border-color:rgba(107,228,255,.18);color:#9dabb0}
.drawer-auth a.primary {border-color:#c8ff63;background:#c8ff63;color:#091014;font-weight:850}
nav.editorial-drawer .nav-con>ul {border-bottom-color:rgba(107,228,255,.1)}
nav.editorial-drawer .nav-con li:hover {background:rgba(107,228,255,.065)}
nav.editorial-drawer .nav-con li a {color:#aab7bb}
nav.editorial-drawer .nav-con li:hover a {color:#9cecff}
nav.editorial-drawer .nav-con li a img {filter:grayscale(1) brightness(1.9)}

/* po_demon14 electric resort mobile navigation */
header.mobile-editorial-header,
header.mobile-editorial-header>.header {border-bottom-color:#dce7f4;background:rgba(255,255,255,.97);box-shadow:0 6px 20px rgba(28,69,122,.08)}
header.mobile-editorial-header h1.logo img {width:102px;max-height:30px}
header.mobile-editorial-header>.header>a:first-child img {filter:invert(28%) sepia(94%) saturate(2600%) hue-rotate(211deg) brightness(93%)}
header.mobile-editorial-header .logininfowrap .icon {border-color:#bdd4ef;background:#eef6ff}
header.mobile-editorial-header .logininfowrap .icon img {filter:invert(28%) sepia(94%) saturate(2600%) hue-rotate(211deg)}
.mobile-editorial-nav .fxhead {border-top-color:#d7e4f2;background:rgba(255,255,255,.98);box-shadow:0 -10px 26px rgba(28,69,122,.11)}
.mobile-editorial-nav .fxhead li span {color:#7990aa}
.mobile-editorial-nav .fxhead li.on span {color:#075ee8;font-weight:750}
.mobile-editorial-nav .fxhead li.on::after {background:#075ee8}
.mobile-editorial-nav .fxhead li em {filter:invert(45%) sepia(12%) saturate(888%) hue-rotate(171deg)}
.mobile-editorial-nav .fxhead li.on em {filter:invert(27%) sepia(99%) saturate(2837%) hue-rotate(213deg) brightness(92%)}
nav.editorial-drawer {background:rgba(7,28,58,.38)}
nav.editorial-drawer .nav-wrap {border-left-color:#d4e2f2;background:linear-gradient(180deg,#fff,#f4f8fe)}
nav.editorial-drawer .nav-head {border-bottom-color:#dce7f4}
nav.editorial-drawer .nav-head .header .logo img {width:112px!important}
nav.editorial-drawer .sideMenu {border-color:#cbdcef;background:#f1f7ff}
nav.editorial-drawer .sideMenu img {filter:invert(28%) sepia(94%) saturate(2600%) hue-rotate(211deg)}
.drawer-user {border-color:#d4e3f3;background:#f5f9ff}
.drawer-user-name span {color:#7e92aa}.drawer-user-name strong {color:#15395f}
.drawer-user-assets button {background:#eaf3ff}.drawer-user-assets span {color:#8194aa}.drawer-user-assets strong {color:#075ee8}
.drawer-auth a {border-color:#cbdbee;color:#516b88}.drawer-auth a.primary {border-color:#075ee8;background:#075ee8;color:#fff}
nav.editorial-drawer .nav-con>ul {border-bottom-color:#dce7f4}
nav.editorial-drawer .nav-con li:hover {background:#eaf3ff}
nav.editorial-drawer .nav-con li a {color:#4e6783}
nav.editorial-drawer .nav-con li:hover a {color:#075ee8}
nav.editorial-drawer .nav-con li a img {filter:invert(34%) sepia(22%) saturate(835%) hue-rotate(171deg)}

/* royal casino mobile navigation */
header.mobile-editorial-header,header.mobile-editorial-header>.header {border-bottom-color:rgba(226,181,83,.28);background:rgba(3,15,34,.98);box-shadow:0 7px 24px rgba(0,0,0,.28)}
header.mobile-editorial-header>.header>a:first-child img,header.mobile-editorial-header .logininfowrap .icon img {filter:invert(78%) sepia(64%) saturate(465%) hue-rotate(355deg)}
header.mobile-editorial-header .logininfowrap .icon {border-color:rgba(226,181,83,.4);background:#0d274b}
.mobile-editorial-nav .fxhead {border-top-color:rgba(226,181,83,.25);background:rgba(3,15,34,.98);box-shadow:0 -10px 28px rgba(0,0,0,.32)}
.mobile-editorial-nav .fxhead li span {color:#7188a4}.mobile-editorial-nav .fxhead li.on span {color:#f0c86b}
.mobile-editorial-nav .fxhead li.on::after {background:#e5b950}.mobile-editorial-nav .fxhead li.on em {filter:invert(79%) sepia(52%) saturate(617%) hue-rotate(355deg)}
nav.editorial-drawer .nav-wrap {border-left-color:rgba(226,181,83,.28);background:linear-gradient(180deg,#071a35,#041127)}
nav.editorial-drawer .nav-head {border-bottom-color:rgba(226,181,83,.2)}
nav.editorial-drawer .sideMenu {border-color:rgba(226,181,83,.3);background:#0c2649}.drawer-user {border-color:rgba(226,181,83,.2);background:#0c2343}
.drawer-user-name span {color:#7590ae}.drawer-user-name strong {color:#fff}.drawer-user-assets button {background:#102e56}.drawer-user-assets span {color:#7891af}.drawer-user-assets strong {color:#efc76b}
.drawer-auth a {border-color:rgba(226,181,83,.24);color:#a7b7c9}.drawer-auth a.primary {border-color:#e2b553;background:linear-gradient(135deg,#f0ca6e,#c78d27);color:#071a37}
nav.editorial-drawer .nav-con>ul {border-bottom-color:rgba(226,181,83,.14)}nav.editorial-drawer .nav-con li:hover {background:rgba(37,105,202,.16)}nav.editorial-drawer .nav-con li a {color:#a4b6ca}nav.editorial-drawer .nav-con li:hover a {color:#f0c86b}

/* Framed MEGA mark */
header.mobile-editorial-header h1.logo a,
nav.editorial-drawer .nav-head h1.logo a {display:flex;min-width:104px;height:38px;padding:0 10px;align-items:center;justify-content:center;border:1px solid rgba(226,181,83,.3);border-radius:9px;background:linear-gradient(135deg,rgba(226,181,83,.11),rgba(17,69,130,.18));box-shadow:inset 0 0 18px rgba(226,181,83,.04)}
header.mobile-editorial-header h1.logo img,
nav.editorial-drawer .nav-head h1.logo img {width:86px!important;max-height:25px!important;filter:saturate(.72) brightness(1.12) drop-shadow(0 2px 8px rgba(226,181,83,.2))}
.mobile-editorial-nav .fxhead li.in.on em,.mobile-editorial-nav .fxhead li.outs.on em {filter:invert(80%) sepia(54%) saturate(611%) hue-rotate(354deg)!important}
.mobile-editorial-nav .fxhead li.in.on span,.mobile-editorial-nav .fxhead li.outs.on span {color:#f0c86b!important}
.mobile-editorial-nav .fxhead li.in em,.mobile-editorial-nav .fxhead li.outs em {border-radius:8px;background-color:#0b2445!important;filter:grayscale(1) brightness(1.75)!important}
.mobile-editorial-nav .fxhead li.in.on em,.mobile-editorial-nav .fxhead li.outs.on em {background-color:rgba(226,181,83,.1)!important;box-shadow:0 0 0 1px rgba(226,181,83,.18)}
</style>
